import christian from "./christian-peer.png";
import dirk from "./dirk-beller.png";
import eric from "./eric-andersen.png";
import logoFrame from "./grundriss-schmiede-logo.png";
import kai from "./kai-koschella.png";
import martin from "./martin-windisch.png";
import violetta from "./violetta-kielpinski.png";

export { christian, dirk, eric, kai, logoFrame, martin, violetta };
